import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTelegramStore } from '@/stores/telegram'

/**
 * Telegram 原生返回鍵：非首頁時顯示，點擊回上一頁。
 * 非 Telegram 環境無 BackButton 物件，安靜跳過。
 */
export function useTelegramBackButton() {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const webApp = useTelegramStore.getState().webApp
    const backButton = webApp?.BackButton
    if (!backButton) return

    const handleBack = () => navigate(-1)

    if (pathname !== '/') {
      backButton.onClick(handleBack)
      backButton.show()
    } else {
      backButton.hide()
    }

    return () => {
      backButton.offClick?.(handleBack)
    }
  }, [pathname, navigate])
}
